import React, {Suspense} from "react";
import {Await, defer, useLoaderData, LoaderFunctionArgs} from "react-router-dom";
import {DemoElearningOverview} from "../../components/Elearning/DemoElearningOverview";
import {CircularProgress} from "@mui/material";
import {getDemoConfig} from "../../api/demoConfigClient";
import {DemoConfig} from "../../model/DemoConfig";

const DemoElearningPage: React.FC = () => {
    const {demoConfig} = useLoaderData() as { demoConfig: Promise<DemoConfig> };

    return (
        <Suspense fallback={<CircularProgress/>}>
            <Await resolve={demoConfig}>
                {config => <DemoElearningOverview 
                    courseUrl={config?.courseUrl || null}
                    courseName={config?.courseName}
                />}
            </Await>
        </Suspense>
    )
}

export default DemoElearningPage

export async function loader({params}: LoaderFunctionArgs) {
    const customerId = params.customerId!;

    return defer({
        demoConfig: loadDemoConfig(customerId)
    })
}

async function loadDemoConfig(customerId: string): Promise<DemoConfig> {
    try {
        const config = await getDemoConfig(customerId);
        return config;
    } catch (error) {
        // If customer is not a demo customer or error occurs, return empty config
        return {};
    }
}
